import {fetchGet} from "../../requests/NetworkRequestAuth0";
import {uri} from "./AppRequest";

export const findVenueDancerDisplay = (
    venueId,
    successMethod,
    errorMethod,
    getAccessToken
) => {
    fetchGet(
        uri + "/user/venue/" + venueId + "/stage/display",
        successMethod,
        errorMethod,
        getAccessToken);
};

export const findStageDisplay = (
    venueId,
    successMethod,
    errorMethod,
    getAccessToken
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/venue/stage/display",
        successMethod,
        errorMethod,
        getAccessToken);
};
